<template>
  <div>
    <v-layout class="mt-3">
      <v-flex>
        <v-btn @click="chooseFile" color="primary" class="text-none subtitle-2">
          <v-icon small class="mr-2">mdi-image</v-icon> Choose Images
        </v-btn>
      </v-flex>
    </v-layout>
    <input
      type="file"
      accept="image/x-png,image/gif,image/jpeg"
      ref="inputRef"
      style="display: none"
      @change="onFileChange"
      multiple
    />
    <v-row class="mt-2" justify="start" v-if="images.length > 0">
      <v-col
        cols="12"
        md="3"
        sm="4"
        lg="3"
        align="start"
        v-for="(image, i) in images"
        :key="i"
      >
        <v-card>
          <v-img
            gradient="to top left, rgba(0,0,0,0), rgba(0,0,0,.7)"
            aspect-ratio="1"
            :src="image.staged"
          >
            <v-layout>
              <v-flex>
                <v-icon color="white" @click="removeImage(i)" class="pa-1"
                  >mdi-close</v-icon
                >
              </v-flex>

              <v-flex text-right class="ma-1">
                <v-btn fab x-small @click="openCropperDialog(i)">
                  <v-icon> mdi-crop </v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
            <v-layout align-center justify-center>
              <v-progress-circular
                color="white"
                size="80"
                :value="uploadProgress.index === i ? uploadProgress.value : 0"
              />
            </v-layout>
          </v-img>
        </v-card>
      </v-col>
      <!-- <v-col> -->
      <!-- <v-btn @click="openCropperDialog"> Crop image </v-btn> -->
      <!-- </v-col> -->
    </v-row>
    <image-cropper-dialog
      @croppedImage="saveCroppedImage"
      ref="ImageCropperDialogRef"
    />
  </div>
</template>

<script>
import ImageCropperDialog from "./ImageCropperDialog.vue";
import { mapState } from "vuex";
export default {
  components: {
    ImageCropperDialog,
  },
  data() {
    return {
      images: [],
    };
  },
  computed: {
    ...mapState("$_assets", ["uploadProgress"]),
  },
  methods: {
    // setImage(e) {
    //   const file = this.images[0].file;
    //   // if (file.type.indexOf("image/") === -1) {
    //   //   alert("Please select an image file");
    //   //   return;
    //   // }
    //   if (typeof FileReader === "function") {
    //     const reader = new FileReader();
    //     reader.onload = (event) => {
    //       this.img = event.target.result;
    //       // rebuild cropperjs with the updated source
    //       // this.$refs.cropper.replace(event.target.result);
    //     };
    //     // console.log(file);
    //     reader.readAsDataURL(file);
    //   } else {
    //     alert("Sorry, FileReader API not supported");
    //   }
    // },
    openCropperDialog(index) {
      console.log("images: ", this.images);
      this.$refs.ImageCropperDialogRef.toggleDialog(this.images[index], index);
    },
    saveCroppedImage(imageObj) {
      this.croppedImage = imageObj.staged;
      // this.images.push(imageObj);
      this.images.splice(imageObj.index, 1, imageObj);

      // if (this.images > 1) {
      //   this.removeImage(0);
      // }
      this.$emit("selectedImage", this.images);
    },
    chooseFile() {
      console.log(this.images);
      this.$refs.inputRef.click();
    },
    resetImages() {
      this.images = [];
    },
    removeImage(index) {
      this.images.splice(index, 1);
    },
    onFileChange(e) {
      // if (e.target.files[0]) {
      //   this.removeImage(0);
      // }

      const file = e.target.files[0];
      e.target.files.forEach((file, index) => {
        let imageObject = {
          staged: URL.createObjectURL(file),
          file,
          progress: 0,
        };
        this.images.push(imageObject);
        this.$emit("selectedImage", this.images);
      });

      // this.setImage(e);
    },
  },
};
</script>

<style>
</style>